module.exports = __webpack_public_path__ + "img/logo_panjang-01.26f8a419.png";